import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import * as S from './styles';

export function Spinner(): JSX.Element {
	return (
		<S.Container>
			<Spin indicator={<LoadingOutlined style={{ fontSize: 38 }} spin />} />
		</S.Container>
	);
}
